module.exports = __webpack_public_path__ + "static/img/sw_bg.d117f41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sw_bg.png
// module id = q3wk
// module chunks = 1